import { BaseService } from './BaseService';
import { Preset, NewsRead } from './SettingsService';

export interface SaveUserSettingResponse {
    isSuccess: boolean;
}

export interface UserSetting {
    presets: Preset[];
    newsRead: NewsRead[];
}

export class UserSettingService extends BaseService {
    save = async (userSetting: UserSetting, accessToken: string): Promise<SaveUserSettingResponse> => {
        return await this.getResponseAsync<SaveUserSettingResponse>(
            {
                commandPath: `user_setting`,
                method: 'POST',
                body: userSetting,
            },
            accessToken,
        );
    };

    load = async (accessToken: string): Promise<UserSetting> => {
        return await this.getResponseAsync<UserSetting>(
            {
                commandPath: `user_setting`,
                method: 'GET',
            },
            accessToken,
        );
    };
}
